var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25996",
    "data-name": "Group 25996",
    transform: "translate(-1368.5 -11974.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1611",
    "data-name": "Ellipse 1611",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1368.5 11974.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "disabled",
    d: "M0,4.249A4.249,4.249,0,1,0,4.249,0,4.254,4.254,0,0,0,0,4.249ZM4.249,7.738a3.487,3.487,0,0,1-2.72-5.671l4.9,4.9A3.471,3.471,0,0,1,4.249,7.738ZM7.738,4.249a3.472,3.472,0,0,1-.77,2.182l-4.9-4.9a3.486,3.486,0,0,1,5.671,2.72Z",
    transform: "translate(1376 11981.199)",
    fill: "#172b37",
    stroke: "#172b37",
    strokeWidth: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.7e51fc93d0825af763e77f6e710f805d.svg";
export { ForwardRef as ReactComponent };